
import { Component, Vue, Watch } from 'vue-property-decorator';
import ShowPopup from '@/components/ShowPopup.vue';
import CreateCompra from './Create.vue';
import { mainStore, userToolStore, compraStore, adminStore } from '@/store';
import DateComponent from '@/components/DateComponent.vue';
import _ from 'lodash';
import { ICompra } from '@/interfaces/compra';

@Component({
  components: {
    DateComponent,
    ShowPopup,
    CreateCompra,
  },
})
export default class Compra extends Vue {
  //Retornos da query principal
  itemsFiltered: any = [];

  //Auxiliares
  isLoading: boolean = true;
  relatorioURL: string = '';
  openFilters: boolean = false;
  dataLancamento: any = null;
  tipoSolicitacao: any = null;
  solicitante: any = null;
  departamento: any = null;
  filial: any = null;
  formaPagamento: any = null;
  users: any = null;
  dataRangePagamento: any = null;

  filters: any = {
    dataLancamento: null,
    tipoSolicitacao: null,
    solicitante: null,
    departamento: null,
    filial: null,
    formaPagamento: null,
    filterFornecedor: null,
  };

  @Watch('filters', { deep: true })
  async onChangeFilter(val) {
    localStorage.setItem('filtersCompras', JSON.stringify(val));
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  get currentUserTool() {
    return (
      _.find(userToolStore.currentUserTools, {
        tool_id: 106,
      }) || {
        allow_view: false,
        allow_edit: false,
        allow_delete: false,
        allow_create: false,
      }
    );
  }

  get headers() {
    return [
      {
        text: 'Data Lançamento',
        sortable: false,
        value: 'data_lancamento',
        align: 'center',
      },
      {
        text: 'Tipo Solicitação',
        sortable: false,
        value: 'tipo_solicitacao',
        align: 'center',
      },
      {
        text: 'Solicitante',
        sortable: false,
        value: 'solicitante',
        align: 'center',
      },
      {
        text: 'Fornecedor',
        sortable: false,
        value: 'fornecedor',
        align: 'center',
      },
      {
        text: 'Responsável Setor',
        sortable: false,
        value: 'responsavel_setor',
        align: 'center',
      },
      {
        text: 'Setor',
        sortable: false,
        value: 'departure_id',
        align: 'center',
      },
      {
        text: 'Filial',
        sortable: false,
        value: 'c008_descricao',
        align: 'center',
      },
      {
        text: 'Material/Serviço',
        sortable: false,
        value: 'material_servico',
        align: 'center',
      },
      {
        text: 'Valor Total',
        sortable: false,
        value: 'valor_total',
        align: 'center',
      },
      {
        text: 'Data Pagamento',
        sortable: false,
        value: 'data_pagamento',
        align: 'center',
      },
      {
        text: 'Forma Pagamento',
        sortable: false,
        value: 'forma_pagamento',
        align: 'center',
      },
      {
        text: 'Condição Pagamento',
        sortable: false,
        value: 'numero_parcelas',
        align: 'center',
      },
      {
        text: 'Nota Fiscal',
        sortable: false,
        value: 'nota_fiscal',
        align: 'center',
      },
      ...this.additionalHeaders,
    ];
  }

  get additionalHeaders() {
    const headers = [];
    if (this.currentUserTool.allow_edit) {
      headers.push({
        text: 'Ações',
        sortable: false,
        value: 'actions',
        align: 'center',
      });
    }
    return headers;
  }

  get items() {
    let items = compraStore.Compras;

    if (this.filters.dataLancamento != null) {
      items = items.filter((f) => this.filters.dataLancamento === f.data_lancamento);
    }

    if (this.filters.formaPagamento != null) {
      if (this.filters.formaPagamento.length > 0) {
        items = items.filter((f) =>
          this.filters.formaPagamento.includes(
            this.formaPagamentoOptions.find((option) => option.name === f.forma_pagamento).id
          )
        );
      }
    }

    if (this.filters.tipoSolicitacao != null) {
      if (this.filters.tipoSolicitacao.length > 0) {
        items = items.filter((f) =>
          this.filters.tipoSolicitacao.includes(
            this.tipoSolicitacaoOptions.find((option) => option.name === f.tipo_solicitacao).id
          )
        );
      }
    }

    if (this.filters.filial != null) {
      if (this.filters.filial.length > 0) {
        items = items.filter((f) => this.filters.filial.includes(f.c008_codigo));
      }
    }

    if (this.filters.departamento != null) {
      if (this.filters.departamento.length > 0) {
        items = items.filter((f) => this.filters.departamento.includes(f.departure_id));
      }
    }

    if (this.filters.solicitante != null) {
      if (this.filters.solicitante > 0) {
        items = items.filter((f) => this.filters.solicitante.includes(f.solicitante));
      }
    }

    if (this.filters.filterFornecedor != '' && this.filters.filterFornecedor != null) {
      items = items.filter((f) => {
        if (f.fornecedor) {
          if (f.fornecedor.toLocaleLowerCase().includes(this.filters.filterFornecedor.toLocaleLowerCase())) {
            return f;
          }
        }
      });
    }

    if (this.dataRangePagamento != null) {
      let dataInicio = new Date(this.dataRangePagamento[0]);
      let dataFim = new Date(this.dataRangePagamento[1]);
      items = items.filter((f) => {
        let dataPagamento = new Date(f['data_pagamento']);
        return dataPagamento >= dataInicio && dataPagamento <= dataFim;
      });
    }
    return items;
  }

  get tipoSolicitacaoOptions() {
    return [
      {
        id: 1,
        name: 'Adiantamento',
      },
      {
        id: 2,
        name: 'Pagamento',
      },
      {
        id: 3,
        name: 'Pagamento de Tour',
      },
      {
        id: 4,
        name: 'Reembolso de Despesas',
      },
    ];
  }

  get usersOptions() {
    return adminStore.usersFranchising.map((user) => {
      user.full_name = '[' + (user.franchising_id === 1 ? 'KNN' : 'PHENOM') + '] ' + user.full_name;
      return user;
    });
  }

  get formaPagamentoOptions() {
    return [
      {
        id: 1,
        name: 'Boleto',
      },
      {
        id: 2,
        name: 'Depósito',
      },
      {
        id: 3,
        name: 'Dinheiro',
      },
      {
        id: 4,
        name: 'Pix',
      },
      {
        id: 5,
        name: 'Cartão de Crédito',
      },
    ];
  }

  async gerarRelatorio() {
    const payload = {
      compras: this.items,
      filtros: [],
    };
    this.isLoading = true;
    this.relatorioURL = await compraStore.getComprasRelatorio(payload);
    this.isLoading = false;
    let mywindow = window.open('_blank', 'scrollbars=yes, resizable=no, height=600,width=700,top=100,left=150');

    //@ts-ignore
    mywindow.document.write(this.relatorioURL);
    //@ts-ignore
    mywindow.document.close(); // necessary for IE >= 10
    //@ts-ignore
    mywindow.focus(); // necessary for IE >= 10*/
  }

  abrir_filtros() {
    this.openFilters = true;
  }

  close_filtros() {
    this.openFilters = false;
  }

  async deleteCompra(compra: ICompra) {
    this.$swal({
      icon: 'warning',
      title: 'Confirmar exclusão',
      text: 'Tem certeza que deseja excluir esta compra? Todos as informações serão perdidas',
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        await compraStore.deleteCompra(compra.id);
        await compraStore.getCompra();
        this.isLoading = false;
      }
    });
  }

  public async mounted() {
    this.isLoading = true;

    await compraStore.getCompra();
    if (localStorage.getItem('filtersCompras')) {
      this.filters = JSON.parse(localStorage.getItem('filtersCompras'));
    }
    this.isLoading = false;
  }
}
